import { gql } from 'graphql-tag';

import { GetCatalogResourcesQuery } from 'src/graphql/generated/graphql';

export const GET_CATALOG_RESOURCES = gql`
  query GetCatalogResources(
    $preview: Boolean!
    $learningLevel: [String]
    $productRole: [String]
    $product: [String]
    $collectionProduct: [String]
    $lessonProduct: [String]
    $deployment: [String]
    $skip: Int
    $searchValue: String
  ) {
    learningPathCollection(
      preview: $preview
      limit: 9
      skip: $skip
      where: {
        AND: [
          {
            deployment_contains_some: $deployment
            learningLevel_in: $learningLevel
            productRole_contains_some: $productRole
            product_contains_some: $product
            hideFromCatalog_exists: false
          }
        ]
        OR: [{ title_contains: $searchValue }, { learningPathSummary_contains: $searchValue }]
      }
    ) {
      items {
        sys {
          id
        }
        __typename
        slug
        title
        learningPathSummary {
          json
        }
        deployment
        learningLevel
        product
        productRole
        coursesCollection(where: { sys: { id_exists: true } }, limit: 20) {
          items {
            lessonsCollection(where: { sys: { id_exists: true } }, limit: 20) {
              items {
                duration
              }
            }
          }
        }
      }
    }
    smCourseCollection(
      preview: $preview
      limit: 9
      skip: $skip
      where: {
        AND: [
          {
            deployment_contains_some: $deployment
            product_contains_some: $product
            productRole_contains_some: $productRole
            learningLevel_in: $learningLevel
            hideFromCatalog_exists: false
          }
        ]
        OR: [{ title_contains: $searchValue }, { overview_contains: $searchValue }]
      }
    ) {
      items {
        sys {
          id
        }
        __typename
        slug
        title
        overview {
          json
        }
        deployment
        product
        productRole
        learningLevel
        lessonsCollection(where: { sys: { id_exists: true } }, limit: 20) {
          items {
            duration
          }
        }
      }
    }
    smLessonCollection(
      preview: $preview
      limit: 9
      skip: $skip
      where: {
        AND: [
          {
            deployment_contains_some: $deployment
            products_contains_some: $lessonProduct
            productRole_contains_some: $productRole
            hideFromCatalog_exists: false
          }
        ]
        OR: [{ title_contains: $searchValue }, { description_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        sys {
          id
        }
        name
        title
        description
        slug
        duration
        deployment
        products
        productRole
      }
    }
    instructorLedTrainingCollection(
      preview: $preview
      limit: 9
      skip: $skip
      where: {
        AND: [
          {
            deployment_contains_some: $deployment
            product_contains_some: $product
            productRole_contains_some: $productRole
            learningLevel_in: $learningLevel
            hideFromCatalog_exists: false
          }
        ]
        OR: [{ courseTitleExternal_contains: $searchValue }, { courseSummary_contains: $searchValue }]
      }
    ) {
      items {
        sys {
          id
        }
        __typename
        title: courseTitleExternal
        slug: intellumUrl
        courseSummary
        deployment
        product
        productRole
        learningLevel
        duration
      }
    }
    certificationCollection(
      preview: $preview
      limit: 9
      skip: $skip
      where: {
        product_contains_some: $collectionProduct
        hideFromCatalog_exists: false
        OR: [{ certificationTitleExternal_contains: $searchValue }, { certificationDescription_contains: $searchValue }]
      }
    ) {
      items {
        sys {
          id
        }
        __typename
        title: certificationTitleExternal
        slug
        product
        certificationDescription
      }
    }
    roleCollection(
      preview: $preview
      limit: 9
      skip: $skip
      where: {
        product_contains_some: $collectionProduct
        hideFromCatalog_exists: false
        OR: [{ titleExternal_contains: $searchValue }, { description_contains: $searchValue }]
      }
    ) {
      items {
        sys {
          id
        }
        __typename
        title: titleExternal
        description
        slug
        product
      }
    }
    topicCollection(
      preview: $preview
      limit: 9
      skip: $skip
      where: {
        product_contains_some: $collectionProduct
        hideFromCatalog_exists: false
        OR: [{ topicTitleExternal_contains: $searchValue }, { topicDescription_contains: $searchValue }]
      }
    ) {
      items {
        sys {
          id
        }
        __typename
        title: topicTitleExternal
        topicDescription
        slug
        product
      }
    }
    certificationPrepCollection(
      preview: $preview
      limit: 9
      skip: $skip
      where: {
        relatedCertification: { product_contains_some: $collectionProduct }
        hideFromCatalog_exists: false
        OR: [{ certificationPrepTitleExternal_contains: $searchValue }, { description_contains: $searchValue }]
      }
    ) {
      items {
        sys {
          id
        }
        __typename
        title: certificationPrepTitleExternal
        description
        slug
        relatedCertification {
          product
        }
      }
    }
  }
`;

export type ContentfulGetCatalogResourcesResponse = GetCatalogResourcesQuery;
export type ContentfulGetLessons = GetCatalogResourcesQuery['smLessonCollection']['items'][0];
export type ContentfulGetCourses = GetCatalogResourcesQuery['smCourseCollection']['items'][0];
export type ContentfulGetLearningPaths = GetCatalogResourcesQuery['learningPathCollection']['items'][0];
export type ContentfulGetCertifications = GetCatalogResourcesQuery['certificationCollection']['items'][0];
export type ContentfulGetRoles = GetCatalogResourcesQuery['roleCollection']['items'][0];
export type ContentfulGetTopics = GetCatalogResourcesQuery['topicCollection']['items'][0];
export type ContentfulGetCertPreps = GetCatalogResourcesQuery['certificationPrepCollection']['items'][0];
export type ContentfulGetInstructorLedTraining =
  GetCatalogResourcesQuery['instructorLedTrainingCollection']['items'][0];
